/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-03-01T16:33:48.761
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getRentFacilityEditInit,
	getRentFacilityView
} from '@api/rentmanage/RentFacility';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary)
	},
	actions: {
		getRentFacilityEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentFacilityEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentFacilityView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentFacilityView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
